import { render } from "./RiWorldOn.vue?vue&type=template&id=6d723a54"
import script from "./RiWorldOn.vue?vue&type=script&lang=js"
export * from "./RiWorldOn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiWorldOn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d723a54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d723a54', __exports__)) {
    api.reload('6d723a54', __exports__)
  }
  
  module.hot.accept("./RiWorldOn.vue?vue&type=template&id=6d723a54", () => {
    api.rerender('6d723a54', render)
  })

}


export default __exports__